/* istanbul ignore file */
import React from 'react';
import MuiButton, { ButtonOwnProps, ButtonProps as MuiButtonProps } from '@mui/material/Button';
import { ButtonLayoutProps } from 'framework/ui/uiContract';

export interface ButtonProps extends Omit<MuiButtonProps, 'color'> {
  component?: React.ElementType;
  buttonTag?: React.ElementType;
  link?: boolean;
  color?: BasicColors;

  // NavLink component props
  end?: boolean;

  // Link component props
  to?: string;
}

export const Button = ({
  link = false,
  variant,
  sx = {},
  disableRipple,
  color,
  ...props
}: ButtonProps | ButtonLayoutProps) => {
  return (
    <MuiButton
      {...props}
      disableRipple={link || disableRipple}
      variant={link ? 'outlined' : variant}
      sx={
        link
          ? {
              ...sx,
              padding: '0 !important',
              background: 'transparent !important',
              border: '0 !important',
              '&:hover': { textDecoration: 'underline' },
            }
          : sx
      }
      color={color as ButtonOwnProps['color']}
    />
  );
};
